<div class="common-wrapper">
    <div class="main-hd-txt">
        <span>
            <h4>BRANCH<span class="head-btn-style">
                <button *ngIf="!listView" (click)="goToBackTab()" class="go-back-btn-head" title="Back Tab">
                    <i class="bi bi-arrow-left-circle"></i> Back</button></span><span class="head-btn-style">
                    <button *ngIf="!listView" id="btn_branch_save" (click)="save($event)" class="save-btn-head" [disabled]="saveDisabled" title="Save">
                    <i class="bi bi-file-earmark-plus"></i> Save</button></span></h4>
        </span>
    </div>
    <div *ngIf="listView" class="top-btns">
        <grid [entities]="locations" [actionExclude]="['feedback','column']" [checkboxCol]="true"
            [entityColumns]="locationColumns" [selectionField]="'Location_Id'" [addEntityIcon]="'bi bi-plus-square'"
            [addEntityCaption]="'Add'" [downloadEntityCaption]="'Download'" (downloadEntities)="onExcelExport()"
            (addEntity)="addLocation($event)" (editEntity)="editLocation($event)"
            (refreshEntities)="refreshLocations($event)" (deleteEntity)="deleteLocation($event)"
            (onPaginationChange)="onPaginationChange($event)" [serverPagination]="true" [pageSizes]="pageSizes"
            [pageSize]="defaultPageSize" [skip]="pageSkip" (onFilterChange)="onFilterChange($event)"></grid>

    </div>

    <div *ngIf="!listView">
        <div class="row sub-head">
            <div class="col-md-7 text-bold">
                {{ formCaption }}
            </div>
            <div class="col-md-5 text-end">
                <button (click)="clearLocation()" class="btn-3 bt-3-ic"><span>Clear</span></button>
                <button (click)="revertChanges()" class="btn-3 bt-4-ic"><span>Revert Changes</span></button>
                <button (click)="gotoBack()" class="btn-3 bt-4-ic"><span>Go Back</span></button>
            </div>
        </div>

        <div class="col-md-12 content-area">
            <div class="row">
                <div class="col-md-4 mb-2">
                    <textbox [caption]="'Branch Name'" [mandatory]="true" [maxlength]="100" [formData]="entity"
                        id="txt_Branch_Name" [fieldName]="'LocationName'" [(ngModel)]="entity.LocationName"
                        ngDefaultControl></textbox>

                </div>
                <div class="col-md-4 mb-2">
                    <textbox [caption]="'Code'" [formData]="entity" [maxlength]="10" [mandatory]="true"
                        id="txt_Branch_code" [fieldName]="'Code'" [(ngModel)]="entity.Code" id="txt_region_Code"
                        ngDefaultControl></textbox>
                </div>

            </div>

            <div class="row">
                <div class="col-md-4 mb-2">
                    <dropdown [caption]="'Branch Head'" [formData]="entity" [data]="employees" [mandatory]="false"
                        id="txt_Branch_Head" [filterable]="true" (filterChanged)="getAllEmployees($event)"
                        [class]="'form-control'" id="drp_region_Head" [(ngModel)]="entity.Emp_Ref_Id"
                        [textField]="'EmployeeName'" [valueField]="'Emp_Ref_Id'" [fieldName]="'Emp_Ref_Id'"
                        [selectedItem]="selectedEmployee" ngDefaultControl>
                    </dropdown>
                </div>
                <div class="col-md-4 mb-2">
                    <textbox [caption]="'Address'" [mandatory]="true" [multiline]="true" [formData]="entity"
                        [maxlength]="50" [fieldName]="'LocationAddress'" [(ngModel)]="entity.LocationAddress"
                        id="txt_Branch_address" ngDefaultControl>
                    </textbox>

                </div>
            </div>
            <div class="row">
                <!-- <div class="col-md-4 mb-2">
                    <dropdown [caption]="'Company'" [formData]="entity" [data]="company" [class] = "'form-control'"
                    [mandatory]="true" [filterable]="true" (filterChanged)="getAllCompany($event)" id="drp_Branch_Company"
                    [(ngModel)]="entity.Company_Id" [textField]="'CompanyName'" [valueField]="'Company_Id'"
                    [fieldName]="'Company_Id'" [selectedItem]="selectedCompany" ngDefaultControl>
                </dropdown>

                </div> -->

                <div class="col-md-4 mb-2">
                    <dropdown [caption]="'Cluster'" [formData]="entity" [data]="cluster" [class]="'form-control'"
                         [filterable]="true" (filterChanged)="getallcluster($event)"
                        id="drp_Branch_Cluster" [(ngModel)]="entity.Cluster_Id" [textField]="'ClusterName'"
                        [valueField]="'Cluster_Id'" [fieldName]="'ClusterName'" [selectedItem]="selectedCluster"
                        (selectionChanged)="clusterchanged($event)" ngDefaultControl>
                    </dropdown>
                </div>
                <div class="col-md-4 mb-2">
                    <textbox [caption]="'Email Id'" [mandatory]="false" [maxlength]="100" [formData]="entity"
                        id="txt_Branch_Email"  [fieldName]="'EmailId'" [(ngModel)]="entity.EmailId"
                        ngDefaultControl>
                    </textbox>
                </div>

            </div>
            <!-- <div class="row">
                <div class="col-md-4 mb-2">
                    <dropdown [caption]="'Area'" [formData]="entity" [data]="division" [class] = "'form-control'"
                    [mandatory]="true" [filterable]="true"  id="drp_Branch_Division"
                    [(ngModel)]="entity.Division_Id" [textField]="'DivisionName'" [valueField]="'Division_Id'"
                    [fieldName]="'Division_Id'" [selectedItem]="selectedDivision"  (selectionChanged)="Divisionchanged($event)" ngDefaultControl>
                </dropdown> 
                </div>
                <div class="col-md-4 mb-2">
                    <dropdown [caption]="'Region'" [formData]="entity" [data]="region" [class] = "'form-control'"
                    [mandatory]="true" [filterable]="true" 
                    [(ngModel)]="entity.Region_Id" [textField]="'RegionName'" [valueField]="'Region_Id'" id="drp_Branch_Region"
                    [fieldName]="'Region_Id'" [selectedItem]="selectedRegion" (selectionChanged)="Regionchanged($event)" ngDefaultControl>
                </dropdown> 
                </div>
                
              
            </div> -->
            <!-- <div class="row">
                <div class="col-md-4 mb-2">
                    <dropdown [caption]="'state'" [formData]="entity" [data]="state"  [class] = "'form-control'"
                    [mandatory]="true" [filterable]="true" 
                    [(ngModel)]="entity.State_Id" [textField]="'StateName'" [valueField]="'State_Id'" id="drp_Branch_state"
                    [fieldName]="'Division_Id'" [selectedItem]="selectedState"  (selectionChanged)="Statechanged($event)" ngDefaultControl>
                </dropdown> 
                </div>
                <div class="col-md-4 mb-2">
                    <dropdown [caption]="'Zone'" [formData]="entity" [data]="zone" [class]="'form-control'"
                        [mandatory]="false" [filterable]="true" (filterChanged)="getAllZone($event)" id="drp_region_Zone"
                        [(ngModel)]="entity.Zone_Id" [textField]="'ZoneName'" [valueField]="'Zone_Id'" id="drp_Branch_Zone"
                        [fieldName]="'Zone_Id'" [selectedItem]="selectedZone" ngDefaultControl>
                    </dropdown>
                </div>
            </div> -->
            <div class="row">
                <div class="col-md-4 mb-2">
                    <textbox [caption]="'Phone'" [mandatory]="false" [maxlength]="10" [formData]="entity"
                        id="txt_Branch_Phone" [fieldName]="'Phone'" (keypress)="numberOnly($event)"
                        [(ngModel)]="entity.Phone" ngDefaultControl></textbox>
                </div>
                <div class="col-md-4 mb-2">
                    <checkbox [caption]="'Active'" [(ngModel)]="entity.IsActive"></checkbox>
                </div>
            </div>
            <!-- <div class="row">
                
            </div> -->
            <div class="row">
                <!-- <div class="col-md-1">
                    <btn [label]="'Back'" (click)="goToBackTab()" [class]="'btn-next btn-11'" [type]="'button'"
                        title="Back Tab"></btn>
                </div>
                <div class="col-md-4 mb-2">
                    <btn [label]="'Save'" (click)="save($event)" [class]="'btn-1 btn-11'" [disabled]="saveDisabled"
                        [type]="'button'" id="btn_branch_save"></btn>
                </div> -->
            </div>
        </div>

    </div>
</div>
<ng-template #view let-dataItem let-rowIndex="rowIndex">
    <i class="bi bi-eye-fill" (click)="open(dataItem)"></i>
  </ng-template>
  <kendo-dialog title="Branch Details" *ngIf="opened" (close)="close()" [height]="500" [width]="1000">
    <div class="col-md-12 content-area">
        <div class="row">
          <div class="col-md-4 br-table-data">
            <label for="LocationName" class="label label-1">Branch Name : </label> {{details.LocationName }}
          </div>
          <div class="col-md-4 br-table-data">
            <label for="Code" class="label label-1">Code : </label> {{details.Code}}
          </div>
          <div class="col-md-4 br-table-data">
            <label for="EmployeeName" class="label label-1">Branch Head : </label> {{details.EmployeeName}}
          </div>
         </div>
          <div class="row">
          <div class="col-md-4 br-table-data">
            <label for="ClusterName" class="label label-1">Cluster : </label>  {{details.ClusterName}}
          </div>
          <div class="col-md-4 br-table-data">
            <label for="Email" class="label label-1">Email Id : </label>  {{details.EmailId}}
          </div>
          <div class="col-md-4 br-table-data">
            <label for="Phone" class="label label-1">Phone Number : </label>  {{details.Phone}}
          </div>
        </div>
        </div>
    </kendo-dialog>

<kendo-excelexport [data]="locations.data" [collapsible]="true" fileName="Branch.xlsx" #excelexport>
    <kendo-excelexport-column field="SlNo" title="Sl.No." [width]="200">
    </kendo-excelexport-column>
    <kendo-excelexport-column field="LocationName" title="Branch" [width]="200">
    </kendo-excelexport-column>
    <kendo-excelexport-column field="LocationCode" title="Code" [width]="200">
    </kendo-excelexport-column>
    <kendo-excelexport-column field="EmployeeName" title="Branch Head" [width]="200">
    </kendo-excelexport-column>
    <!-- <kendo-excelexport-column field="LocationAddress" title="Address" [width]="200">
    </kendo-excelexport-column> -->
    <kendo-excelexport-column field="LocationMail" title="Email" [width]="200">
    </kendo-excelexport-column>
    <kendo-excelexport-column field="LocationPhone" title="Phone" [width]="200">
    </kendo-excelexport-column>
    <!-- <kendo-excelexport-column field="CompanyName" title="Company" [width]="200">
    </kendo-excelexport-column>  -->
    <kendo-excelexport-column field="ClusterName" title="Cluster" [width]="200">
    </kendo-excelexport-column>
    <kendo-excelexport-column field="Active" title="Active" [width]="200">
    </kendo-excelexport-column>
</kendo-excelexport>